/* global axios */
import ApiClient from './ApiClient';

class AppointmentsAPI extends ApiClient {
  constructor() {
    super('appointments', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  create(data = {}) {
    return axios.post(this.url, data);
  }

  // NOTE: there is no hard-delete endpoint. The DELETE route soft-cancels the
  // appointment (controller#destroy authorizes :cancel? and runs
  // CancellationService). delete() is just cancel() without a reason; prefer
  // cancel() so the cancellation reason is recorded.
  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // Cancel uses DELETE (the Rails destroy action, which soft-cancels) with an
  // optional reason param.
  cancel(id, data = {}) {
    const params = data.reason ? { reason: data.reason } : {};
    return axios.delete(`${this.url}/${id}`, { params });
  }

  // Routes define POST (not PATCH) for these status transitions
  confirm(id) {
    return axios.post(`${this.url}/${id}/confirm`);
  }

  complete(id) {
    return axios.post(`${this.url}/${id}/complete`);
  }

  noShow(id) {
    return axios.post(`${this.url}/${id}/no_show`);
  }

  update(id, data = {}) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  availability(params = {}) {
    return axios.get(`${this.url}/availability`, { params });
  }

  // Returns professionals available at a given slot (filters out: outside
  // working_hours, conflicting appointments — cancelled/no_show do not count).
  // params: { scheduled_at: ISO string, duration_minutes?: number, service_id?: number }
  availableProfessionals(params = {}) {
    return axios.get(`${this.url}/available_professionals`, { params });
  }

  exportCsv(params = {}) {
    return axios.get(`${this.url}/export`, {
      params,
      responseType: 'blob',
    });
  }

  metrics(params = {}) {
    return axios.get(`${this.url}/metrics`, { params });
  }

  // eslint-disable-next-line class-methods-use-this
  contactHistory(accountId, contactId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/contacts/${contactId}/appointment_history`
    );
  }
}

export default new AppointmentsAPI();
